import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-topup-success',
    templateUrl: './topup-success.component.html',
    styleUrls: ['./topup-success.component.css']
})
export class TopupSuccessComponent implements OnInit, OnDestroy {

    countdown = 5;
    private timer: any;

    constructor(private router: Router) { }

    ngOnInit(): void {
        this.timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
                this.goToDevices();
            }
        }, 1000);
    }

    ngOnDestroy(): void {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    goToDevices(): void {
        clearInterval(this.timer);
        this.router.navigate(['/devices']);
    }
}
